import { client } from "./fetch";
import {
    ContactNumberLeadRequest,
} from "./types";
import * as globals from './globals';

export const createContactNumberLead = async (
    data: ContactNumberLeadRequest
): Promise<{message: string} | void> => {
   
    const utmParams = globals.get(globals.keys.utmParams);
    const fbAnalyticsParams = globals.get(globals.keys.fbAnalyticsParams);

    const response = await client.post<ContactNumberLeadRequest, {message: string}>(
        {
            url: `/bikri/shopdeck/lead-contact-number`,
            payload: {
                ...data,
                visitor_id: globals.get(globals.keys.visitorId) || "",
                session_id: globals.get(globals.keys.sessionId) || "",
                language: navigator.language,
                userAgent: navigator.userAgent,
                utm_source: utmParams && utmParams.utm_source ? utmParams.utm_source : ' ',
                utm_campaign: utmParams &&  utmParams.utm_campaign ? utmParams.utm_campaign : '',
                utm_medium: utmParams && utmParams.utm_medium ? utmParams.utm_medium : '',
                utm_content: utmParams && utmParams.utm_content ?utmParams.utm_content : '',
                utm_term: utmParams && utmParams.utm_term ? utmParams.utm_term : '',
                pathname: window.location.pathname,
                campaign_id: utmParams && utmParams.campaign_id ? utmParams.campaign_id : '',
                ad_group_id: utmParams && utmParams.adgroupid ? utmParams.adgroupid : '',
                creative: utmParams && utmParams.creative ? utmParams.creative : '',
                keyword: utmParams && utmParams.keyword ? utmParams.keyword : '',
                target_id: utmParams && utmParams.targetid ? utmParams.targetid : '',
                placement: utmParams && utmParams.placement ? utmParams.placement : '',
                ad_position: utmParams && utmParams.adposition ? utmParams.adposition : '',
                network: utmParams && utmParams.network ? utmParams.network : '',
                google_device: utmParams && utmParams.device ? utmParams.device : '',
                device_model: utmParams && utmParams.devicemodel ? utmParams.devicemodel : '',
                match_type: utmParams && utmParams.matchtype ? utmParams.matchtype : '',
                loc_physical_ms: utmParams && utmParams.loc_physical_ms ? utmParams.loc_physical_ms : '',
                gclid: utmParams && utmParams.gclid ? utmParams.gclid : '',
                fbc: fbAnalyticsParams && fbAnalyticsParams.fbc ? fbAnalyticsParams.fbc : '',
                fbp: fbAnalyticsParams && fbAnalyticsParams.fbp ? fbAnalyticsParams.fbp : '',
            },
        }
    );
    return response.data;
};
